import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { TemplateBuilder } from '~/components/form-templates/template-builder'
import { titleFor } from '~/lib/route-title'
import type { Id } from '~convex/_generated/dataModel'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/templates/$templateId')({
  component: TemplateRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Template`) }] }),
})

function TemplateRoute() {
  const { templateId } = Route.useParams()
  return <TemplateBuilder templateId={templateId as Id<'formTemplates'>} />
}
